/** Milliseconds a timer currently shows at `nowMs`. */
export function timerValueMs(timer, nowMs) {
    const runningDelta = timer.running && timer.startedAt !== null ? nowMs - timer.startedAt : 0;
    if (timer.mode === 'countUp') {
        return Math.max(0, timer.baseMs + runningDelta);
    }
    return Math.max(0, timer.baseMs - runningDelta);
}
/** Severity of a count-down timer for colour/emphasis (never colour alone in UI). */
export function timerLevel(timer, nowMs) {
    if (timer.mode !== 'countDown')
        return 'normal';
    const remaining = timerValueMs(timer, nowMs);
    if (remaining <= timer.urgentMs)
        return 'urgent';
    if (remaining <= timer.warnMs)
        return 'warn';
    return 'normal';
}
/** Format ms as m:ss (or h:mm:ss beyond an hour). */
export function formatTimer(ms) {
    const totalSec = Math.floor(ms / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    const mm = String(m).padStart(h > 0 ? 2 : 1, '0');
    const ss = String(s).padStart(2, '0');
    return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
function applyToTimer(timer, control, nowMs) {
    switch (control.action) {
        case 'start':
            if (timer.running)
                return timer;
            return { ...timer, running: true, startedAt: nowMs, visible: true };
        case 'pause': {
            if (!timer.running)
                return timer;
            const value = timerValueMs(timer, nowMs);
            return { ...timer, running: false, startedAt: null, baseMs: value };
        }
        case 'reset':
            return {
                ...timer,
                running: false,
                startedAt: null,
                baseMs: timer.mode === 'countDown' ? timer.durationMs : 0,
            };
        case 'setDuration': {
            const durationMs = Math.max(0, control.value ?? timer.durationMs);
            return { ...timer, durationMs, baseMs: timer.mode === 'countDown' ? durationMs : timer.baseMs };
        }
        case 'show':
            return { ...timer, visible: true };
        case 'hide':
            return { ...timer, visible: false };
        default:
            return timer;
    }
}
export function applyTimerControl(timers, control, nowMs) {
    if (control.which === 'production') {
        return { ...timers, production: applyToTimer(timers.production, control, nowMs) };
    }
    return { ...timers, segment: applyToTimer(timers.segment, control, nowMs) };
}
//# sourceMappingURL=timers.js.map